import { Heading } from 'blaze-ui/Heading/Heading'
import Styles from './ReferralModalV2.module.scss'
import { Gift01, LinkAngled } from 'blaze-ui/icons'
import { Text } from 'blaze-ui/Text/Text'

export const CreditsReferralRewards = ({ referrals }: { referrals: number }) => {
  return (
    <div className={Styles.creditsReferralRewardsContainer}>
      <div className={Styles.header}>
        <Heading level={5} color="var(--dark-80)">
          How it works:
        </Heading>
        <Heading level={5} color="var(--dark-40)">
          Link used by <span style={{ color: 'var(--dark-80)' }}>{referrals}</span> users
        </Heading>
      </div>
      <div className={Styles.inviteLink}>
        <LinkAngled color="#8626FF" />
        <Text color="var(--dark-80)">Share your invite link</Text>
      </div>
      <div className={Styles.explanation}>
        <Gift01 color="#8626FF" />
        <Text color="var(--dark-80)">
          You get <strong>500 credits</strong> once they start a subscription.
        </Text>
      </div>
    </div>
  )
}
